/* eslint-disable jsx-a11y/heading-has-content */
import { ReactElement } from 'react';

import { TypographyVariant } from './Typography.types';

export const TYPOGRAPHY_MAP: Record<TypographyVariant, ReactElement> = {
  p1: <p />,
  p2: <p />,
  p3: <p />,
  h1: <h1 />,
  h2: <h2 />,
  h3: <h3 />,
  h4: <h4 />,
  h5: <h5 />,
  sub1: <h6 />,
};

export const FONT_SIZE_MAP: Record<TypographyVariant, number> = {
  p1: 18,
  p2: 16,
  p3: 14,
  h1: 42,
  h2: 32,
  h3: 28,
  h4: 24,
  h5: 18,
  sub1: 18,
};

export const LINE_HEIGH_MAP: Record<TypographyVariant, number> = {
  p1: 22,
  p2: 20,
  p3: 18,
  h1: 42,
  h2: 32,
  h3: 28,
  h4: 25,
  h5: 23,
  sub1: 22,
};
